import { render, staticRenderFns } from "./ContractPaymentRequests.vue?vue&type=template&id=6976b6ce&"
import script from "./ContractPaymentRequests.vue?vue&type=script&lang=js&"
export * from "./ContractPaymentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports